const inFlight = new Map<string, Promise<unknown>>();

/**
 * Share one in-flight promise per key so React Strict Mode (and any
 * accidental double-dispatch) does not fire the same HTTP request twice.
 */
export function dedupeAsync<T>(key: string, run: () => Promise<T>): Promise<T> {
  const existing = inFlight.get(key);
  if (existing) {
    return existing as Promise<T>;
  }

  const promise = run().finally(() => {
    if (inFlight.get(key) === promise) {
      inFlight.delete(key);
    }
  });

  inFlight.set(key, promise);
  return promise;
}
